import BaseMap from './Map';

// EXPORT
export const Map = BaseMap;
export type { MapProps } from './Map.interface';
